/**
 * pictureSliderModule 图片轮播
 * author Qian.qianchen
 * 2019-06-22
 */
'use strict';
angular.module('pictureSliderModule', [])
    .directive('pictureSlider', ['$q', 'trsHttpService', function($q, trsHttpService) {
        return {
            // name: '',
            // priority: 1,
            // terminal: true,
            scope: {
                trackId: "=",
            },
            restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
            templateUrl: './planningCenter/realTimeClues/plannedClues/tracingMonitoring/directive/pictureSlider/pictureSlider_tpl.html',
            replace: true,
            // transclude: true,
            // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
            link: function($scope, iElm, iAttrs, controller) {
                initStatus();
                getPicturesData();
                /**
                 * [initStatus description] 状态初始化
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {
                        page: {
                            currPage: 0,
                            pageSize: 15
                        },
                        hasPrev: false,
                        hasNext: true
                    }
                    $scope.data = {
                        picturesList: [],
                        currIndex: 0
                    }
                }
                /**
                 * [getPicturesData description] 获取图片数据
                 * @return {[type]} [description]
                 */
                function getPicturesData() {
                    let defer = $q.defer();
                    let params = {
                        id: $scope.trackId,
                        page_no: $scope.status.page.currPage,
                        page_size: $scope.status.page.pageSize,
                        serviceid: 'monitortrack',
                        modelid: 'trackPics'
                    }
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "get").then((data) => {
                        $scope.data.picturesList = data.FIRSTPAGE ? data.PAGEITEMS : $scope.data.picturesList.concat(data.PAGEITEMS);
                        // $scope.data.currPicture = $scope.data.picturesList[$scope.data.currIndex];
                        $scope.status.page.pageTotal = data.PAGETOTAL;
                        defer.resolve();
                    });
                    return defer.promise;
                }
                /**
                 * [goPrev description] 上一页
                 * @return {[type]} [description]
                 */
                $scope.goPrev = function() {
                        if ($scope.data.currIndex == 0) {
                            return;
                        }
                        $scope.data.currIndex--;
                        if ($scope.data.currIndex == 0) {
                            $scope.status.hasPrev = false;
                        } else {
                            $scope.status.hasPrev = true;
                        }
                        $scope.status.hasNext = true;
                        let picWidth = $(iElm).find('.picbox').eq($scope.data.currIndex).width();
                        let scrollLeft = $(iElm).find('.pictures_container').scrollLeft();
                        $(iElm).find('.pictures_container').animate({ scrollLeft: scrollLeft - picWidth - 16 + 'px' }, 200, 'swing');
                    }
                    /**
                     * [goNext description] 下一页
                     * @return {[type]} [description]
                     */
                $scope.goNext = function() {
                    if ($scope.data.currIndex >= $scope.data.picturesList.length - 4 && $scope.status.page.pageTotal > $scope.status.page.currPage - 1) {
                        $scope.status.page.currPage++;
                        getPicturesData();
                    }
                    if ($scope.data.currIndex == $scope.data.picturesList.length - 1) {
                        return;
                    }
                    $scope.status.hasPrev = true;
                    let picWidth = $(iElm).find('.picbox').eq($scope.data.currIndex).width();
                    $scope.data.currIndex++;
                    if ($scope.data.currIndex == $scope.data.picturesList.length - 1) {
                        $scope.status.hasNext = false;
                    } else {
                        $scope.status.hasNext = true;
                    }
                    let scrollLeft = $(iElm).find('.pictures_container').scrollLeft();
                    $(iElm).find('.pictures_container').animate({ scrollLeft: scrollLeft + picWidth + 16 + 'px' }, 200, 'swing');
                }
            }
        }
    }]);